import { Dispatch } from 'redux';
import { comoLinkActions } from './actions';
import { isInsideProgram, recordProgramOpenIntent } from './entryIntent';

interface MenuProgram {
  path: string;
  programId?: string;
  comoBacked?: boolean;
  regularLink?: boolean;
}

// From elsewhere the gate has not mounted yet, so leave an intent; inside the program the mounted gate is told directly.
export const openProgram = (page: MenuProgram, currentPath: string, dispatch: Dispatch): void => {
  if (!page.comoBacked || page.regularLink || !page.programId) return;

  if (isInsideProgram(page.path, currentPath)) {
    dispatch(comoLinkActions.programOpenRequested({ programId: page.programId }));
  } else {
    recordProgramOpenIntent(page, currentPath, Date.now());
  }
};
